module.exports = __webpack_public_path__ + "static/media/chevron-left-circle.a101d819.svg";